<template>
  <div class="tw-w-full tw-px-6 tw-pb-20">
    <TooltipTour
      ref="tour"
      :steps="reviewTour"
      :show="showSelfServeReviewTabTutorial"
      tourName="self_serve_interested"
      @tour-finished="handleTourFinished"
    />
    <ProgressState
      v-if="showProgressState && !isSelfServeProject"
      :progress="progress"
      :is_calibration="is_calibration"
    />
    <div
      v-if="
        !showProgress ||
        (showProgress && tab !== 'UNDER_REVIEW' && !isCalibration) ||
        isSelfServeProject
      "
      class="tw-w-full"
    >
      <div
        v-if="isCalibration"
        class="tw-h-[44px] tw-bg-bg-2 tw-px-6 tw-py-2 tw-flex tw-justify-center tw-items-center tw-w-full tw-rounded-lg tw-mb-5"
      >
        <div class="tw-flex tw-items-center tw-gap-6">
          <Typography variant="button-2">
            Calibrating... ({{ 10 - currentProjectReviewCount + 1 }} of 10)
          </Typography>
        </div>
      </div>

      <CalibrationEmptyState
        v-if="showEmptyCalibrationState"
        @calibrate="onChangeCalibration(true)"
      />
      <PanelProgressBar
        v-if="
          isSelfServeProject && showProgressState && candidates.length === 0
        "
        :progress="progress"
      />
      <EmptyState
        v-if="
          !showProgressState &&
          showNormalEmptyState &&
          !showEmptyCalibrationState &&
          !loading3 &&
          !loading
        "
        :image="EmptyStateIcon"
        text="No candidates yet"
      />
      <v-container
        v-if="
          candidateDisplay.length === 0 &&
          !isLoading &&
          !isLoadingCandidate &&
          !isGolive &&
          !isCriticalApproval &&
          isFinishedGolive
        "
        class="pa-0 tw-bg-purple-50 text-center empty-state-golive"
      >
        <div class="content">
          <div>
            <div class="logo-icon"><img :src="EmptyIcon" alt="" /></div>
          </div>
          <div>
            <h3 class="mt-6">Stay tuned!</h3>
            <p>
              Hirefly will notify you when there are interested candidates for
              your project. <br />
              In the meantime, feel free to calibrate your search to train our
              AI to find you the best candidates.
            </p>
          </div>
        </div>
      </v-container>

      <v-progress-circular
        v-if="
          isLoading || isLoadingCandidate || loading2 || loading3 || loading
        "
        :size="72"
        :width="6"
        color="primary"
        indeterminate
        class="center-spinner"
      ></v-progress-circular>

      <div v-if="(candidateDisplay.length || isLoading) && !loading3">
        <CardPile
          ref="cardPileRef"
          :isInCalibrationNewProject="isInCalibrationNewProject"
          :candidates="candidateDisplay"
          :projectId="projectId"
          :shouldRenderLSD="shouldRenderLSD"
          :tab="tab"
          :currentTab="currentTab"
          :currentUserRole="currentUserRole"
          :loading="isLoading || loading"
          :loading2="loading2"
          :isLoadingCandidate="isLoadingCandidate"
          :displayClipBoard="displayClipBoard"
          :projectData="projectData"
          :isCalibration="isCalibration"
          :iscurrentGolive="iscurrentGolive && !closeIntro2"
          :isShowIntro2="isShowIntro"
          :introStep="introStep"
          :showFakeCard="isShowIntro && !candidates.length"
          :totalCandidates="totalCandidates"
          :candidateIndex="candidateIndex"
          :pageIdx="pageIdx"
          :limit="limit"
          :currentCandidate="currentCandidate"
          @changecalibration="onChangeCalibration"
          @prevent-approve-need-calendar-sync="
            showNeedCalendarAuthDialog = true
          "
          @closeInfo="$emit('closeInfo')"
          @closeIntro="closeIntroHandler"
          @disabled-right-side="onDisabledRightSide"
          @next-candidate="nextCandidate"
          @prev-candidate="previousCandidate"
          @expand-email="onOpenRightdrawer(0)"
        />
        <SidePanel
          ref="sidePanelRef"
          v-bind:candidates="[currentCandidate]"
          :projectId="projectId"
          :tab="tab"
          :currentUserRole="currentUserRole"
          :loading="isLoading"
          expanded
          :calendarSetupNeeded="calendarSetupNeeded"
          :isCalibration="isCalibration"
          :isShowIntro="isShowIntro"
          :showFakeCard="isShowIntro && !candidates.length"
          :isDiabledRightSide="isDiabledRightSide"
          @loading2="setLoading2"
          @changecalibration="onChangeCalibration"
        />
      </div>
    </div>
    <v-dialog v-model="showCalendarSetupDialog" width="25rem" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Let's set up your calendar
        </v-card-title>

        <v-card-text class="mt-4">
          While we fetch your candidates, let's set up your calendar, so you can
          receive interviews.
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="transitionUserToCalendarSetup">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <NeedCalendarAuthDialog
      :project-settings="projectSettings"
      :show-need-calendar-auth-dialog="showNeedCalendarAuthDialog"
      @close="showNeedCalendarAuthDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import consola from 'consola';
import { defaultCandidate, selfServeReviewTour } from '@/js/data';
import STATUS from '@/store/status';
import EmptyIcon from '@/assets/img/inclined-rocket-svgrepo-com.svg';
import CalibrationEmptyState from '@/components/panel/components/CalibrationEmptyState';
import PanelProgressBar from '@/components/panel/components/ProgressBar';
import LogoIcon4 from '@/assets/img/presentation-cards-svgrepo-com.svg';
import NeedCalendarAuthDialog from '@/components/panel/components/NeedCalendarAuthDialog';
import Typography from '@/components/v3/base/Typography';
import EmailIcon from '@/assets/icons/mail-purple.svg';
import EmptyStateIcon from '@/assets/icons/empty-state-icon.png';
import CardPile from './CardPile';
import SidePanel from './SidePanel';
import EmptyState from './EmptyState';
import ProgressState from './ProgressState';

const COMPLETED_IMAGE = require('@/assets/img/team.png');
const EMPTY_STATE_IMAGE = require('@/assets/img/empty-review.png');
const EMPTY_STATE_NEW_USER_IMAGE = require('@/assets/img/empty-new-user.png');

export default {
  components: {
    CardPile,
    SidePanel,
    EmptyState,
    ProgressState,
    TooltipTour: () => import('../information-tours/TooltipTour'),
    CalibrationEmptyState,
    PanelProgressBar,
    NeedCalendarAuthDialog,
    Typography,
  },

  props: {
    projectId: String,
    currentUserRole: Number,
    tab: { type: String, required: false, default: 'UNDER_REVIEW' },
    projectSettings: Object,
    isInCalibrationNewProject: Boolean,
    autopilot_golive: Boolean,
    isShowIntro: Boolean,
    isSelfServe: Boolean,
    isCalibration: Boolean,
    currentTab: [Number, String, Boolean],
    introStep: [Number, String],
    tabs: {
      type: Array,
      default: () => [],
    },

    displayClipBoard: Boolean,
    projectData: {
      type: Object,
      default: () => {},
    },

    totalCandidates: Number,
    tabsNames: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      limit: 50,
      calendarSetupNeeded: false,
      PRDResponse: this.$store.getters['projects/getPRD'](this.projectId),
      leftSwipeDialog: false,
      startLoad: false,
      expansionDialog: false,
      selfServeExpansionDialog: false,
      loading2: false,
      EmptyIcon,
      currentProjectName: this.projectSettings.project_name,
      goTour: false,
      isDiabledRightSide: false,
      isShowCriticalApproval: false,
      isFinished: false,
      closeIntro2: false,
      failedAts: false,
      failedCalendar: false,
      liveStep: 0,
      start: false,
      EmptyStateIcon,
      startShowProgress: false,
      reviewTour: selfServeReviewTour,
      showReviewTour: false,
      showNeedCalendarAuthDialog: false,
      historyContents: [
        'The history app maintains a candidate’s progression through the hiring process. You will be able to see the different stages a candidate has been in and who from your team was involved at each step.',
      ],

      notesContents: [
        'This is your personal space to write notes about the candidate. Your notes will be saved onto the candidate and can be viewed at any time in the future. Your notes will not be shared with your team.',
      ],

      chatContents: [
        'Use Hirefly’s Chat app to chat with your teammates about a candidate. You can assign tasks to your teammates, and they will receive notifications to review your task. ',
      ],

      emailContents: [
        'Autopilot Users will be able to see the Initial outreach and any correspondence with the candidate by mail in ‘thread’ format. You will be able to correspond with the candidate, answer any questions asked by the candidate.',
      ],

      calibrationContents: [
        'You can calibrate your search anytime to train Hirefly’s AI to find more suitable candidates. Flip on the switch and review the candidates presented to you. Hirefly will learn from your approval and rejection patterns to improve your candidate quality. Flip off the switch to return to your main dashboard. ',
      ],

      EmailIcon,
      candidateIndex: 0,
      pageIdx: 1,
      loading: false,
      loading3: false,
    };
  },

  computed: {
    isNewEmptyState() {
      return (
        this.isInterestedEmptyState ||
        this.isNeedAttentionEmptyState ||
        this.isFirstInterestedEmptyState
      );
    },

    isSuperAdmin() {
      return this.$store.getters['user/getIsSuperAdmin'];
    },

    isFirstInterested() {
      let result = true;
      this.tabs.forEach((item) => {
        if (this.currentProject[`candidates_${item.key}_count`] !== 0) {
          result = false;
        }
      });
      return result;
    },

    isInterestedEmptyState() {
      return (
        (this.tab === 'WARM_LEADS_RECRUITER' ||
          this.tab === 'WARM_LEADS_HM' ||
          this.tab === 'HIRING_MANAGER' ||
          this.tab === 'AUTOPILOT_RECRUITER') &&
        !this.isInCalibrationNewProject &&
        !this.isFirstInterested
      );
    },

    isNeedAttentionEmptyState() {
      return this.tab === 'WARM_LEADS_QUESTION' || this.tab === 'QUESTION';
    },

    isFirstInterestedEmptyState() {
      return (
        (this.tab === 'WARM_LEADS_RECRUITER' ||
          this.tab === 'WARM_LEADS_HM' ||
          this.tab === 'HIRING_MANAGER' ||
          this.tab === 'AUTOPILOT_RECRUITER') &&
        !this.isInCalibrationNewProject &&
        this.isFirstInterested
      );
    },

    emptyText() {
      if (this.isInterestedEmptyState || this.isFirstInterestedEmptyState)
        return 'Stay tuned!';
      if (this.isNeedAttentionEmptyState) return 'More to come soon!';
      return '';
    },

    emptyImage() {
      if (this.isInterestedEmptyState || this.isFirstInterestedEmptyState)
        return EmptyIcon;
      if (this.isNeedAttentionEmptyState) return LogoIcon4;
      return '';
    },

    emptyContent() {
      if (this.isInterestedEmptyState || this.isFirstInterestedEmptyState)
        return 'Hirefly will notify you when there are interested candidates for your project. In the meantime, feel free to calibrate your search at any time, to train our AI to find you the best candidates. ';
      if (this.isNeedAttentionEmptyState)
        return 'Hirefly will notify you when there are more candidates. <br/>You can calibrate your project at any time to train our AI to see better candidates.';
      return '';
    },

    isSelfServeProject() {
      return this.currentProject.is_self_serve;
    },

    showNormalEmptyState() {
      return (
        this.candidateDisplay.length === 0 &&
        !this.isLoading &&
        !this.isLoadingCandidate &&
        !this.isGolive &&
        !this.isCriticalApproval &&
        !this.isFinishedGolive
      );
    },

    showCalibrationMode() {
      return (
        this.isPilot &&
        !this.isLoading &&
        (!this.isInCalibrationNewProject ||
          (this.isSelfServeProject && this.isInCalibrationNewProject))
      );
    },

    showEmptyCalibrationState() {
      return (
        this.isPilot &&
        this.isSelfServeProject &&
        this.showCalibrationMode &&
        !this.isCalibration &&
        this.showProgress &&
        this.isInCalibrationNewProject
      );
    },

    showProgressState() {
      return (
        this.showProgress && (this.tab === 'UNDER_REVIEW' || this.isCalibration)
      );
    },

    status() {
      return this.$store.getters['projects/candidates/getStatus'](
        this.projectId,
        this.tab
      );
    },

    candidates() {
      const tab = this.isCalibration ? 'UNDER_REVIEW' : this.tab;

      return (
        this.$store.getters['projects/candidates/listCandidates'](
          this.projectId,
          tab
        ) || []
      );
    },

    candidateDisplay() {
      if (this.isShowIntro && !this.candidates.length) {
        return defaultCandidate;
      }
      return this.candidates;
    },

    showSelfServeReviewTabTutorial() {
      if (!this.isSelfServe) return false;
      if (this.showReviewTour) return true;
      if (this.isCalibration || this.candidates.length === 0) {
        return false;
      }
      const user = this.$store.getters['user/getUser'];
      if (
        !user.onboarding_tours ||
        user.onboarding_tours.self_serve_interested
      ) {
        return false;
      }
      return true;
    },

    shouldRenderLSD() {
      const lsdProjects = this.$store.getters[
        'projects/getLeftSwipeDialogProjects'
      ](this.projectId);
      return lsdProjects.includes(this.projectId);
    },

    shouldRenderPRD() {
      const prdProjects = this.$store.getters['projects/getPRD'](
        this.projectId
      );

      return prdProjects.includes(this.projectId);
    },

    isLoading() {
      return this.status === STATUS.LOADING;
    },

    showProgress() {
      consola.info('showProgress');
      consola.info(this.progress);
      return this.progress !== undefined;
    },

    showCalendarSetupDialog() {
      const projects = this.$store.getters['projects/listProjects'];
      // console.log(projects.length)
      consola.info('Showing calendar setup dialog');
      return (
        this.progress !== undefined &&
        this.calendarSetupNeeded === true &&
        projects.length === 1
      );
    },

    progress() {
      const value = this.$store.getters['projects/candidates/getProgress'](
        this.projectId
      );
      if (value) {
        consola.info(`progress of ${this.projectId} is ${value[0]}`);
        return value[0];
      }
      return value;
    },

    is_calibration() {
      const value = this.$store.getters['projects/candidates/getProgress'](
        this.projectId
      );
      if (value) {
        consola.info(`is in calibration value is ${value[1]}`);
        return value[1];
      }
      return value;
    },

    isLoadingCandidate() {
      return this.$store.getters['projects/candidates/getIsLoading'];
    },

    currentCandidate() {
      return (
        this.candidateDisplay[this.candidateIndex] ?? this.candidateDisplay[0]
      );
    },

    reviewCompleted() {
      const project = this.getProjectById(this.projectId);
      return project && project.candidates_review_count === 0;
    },

    emptyStateImage() {
      if (this.reviewCompleted) {
        return COMPLETED_IMAGE;
      }
      if (this.projectId) {
        return EMPTY_STATE_IMAGE;
      }
      return EMPTY_STATE_NEW_USER_IMAGE;
    },

    emptyStateText() {
      if (this.reviewCompleted && !this.isPilot) {
        return this.$lang.Panel.null_title_done;
      }
      if (this.projectId) {
        if (
          this.tab === 'WARM_LEADS_RECRUITER' ||
          this.tab === 'WARM_LEADS_HM' ||
          this.tab === 'HIRING_MANAGER' ||
          this.tab === 'AUTOPILOT_RECRUITER'
        ) {
          return this.$lang.Panel.null_title_interested;
        }
        return this.$lang.Panel.null_title_under_review;
      }
      return `Welcome, ${localStorage.getItem('first_name')}!`;
    },

    isPilot() {
      return this.currentProject.in_auto_swipe_mode;
    },

    isRecruiter() {
      return this.currentProject.is_warmleads_recruiter;
    },

    currentProjectReviewCount() {
      if (!this.projectId) {
        return 0;
      }
      return this.currentProject.candidates_review_count;
    },

    currentProject() {
      if (!this.projectId) {
        return {};
      }

      return (
        this.$store.getters['projects/getProjectById'](this.projectId) || {}
      );
    },

    isNotPauseProject() {
      return (
        !this.currentProject.outreach_pause && !this.currentProject.is_archived
      );
    },

    isGolive() {
      return (
        this.isPilot &&
        !this.isRecruiter &&
        this.autopilot_golive &&
        this.candidates.length === 0 &&
        !this.isLoading &&
        !this.isLoadingCandidate &&
        !this.goTour &&
        this.isNotPauseProject
      );
    },

    isFinishedGolive() {
      return (
        this.isPilot &&
        !this.isRecruiter &&
        this.autopilot_golive &&
        this.candidates.length === 0 &&
        !this.isLoading &&
        !this.isLoadingCandidate &&
        this.isNotPauseProject
      );
    },

    iscurrentGolive() {
      return (
        this.isPilot &&
        !this.isRecruiter &&
        this.autopilot_golive &&
        !this.isLoading &&
        !this.isLoadingCandidate &&
        !this.goTour &&
        this.isFinished &&
        this.isNotPauseProject
      );
    },

    isCriticalApproval() {
      return (
        !this.isRecruiter &&
        !this.isGolive &&
        (this.tab === 'WARM_LEADS_HM' || this.tab === 'HIRING_MANAGER') &&
        this.candidates.length === 0 &&
        !this.isLoading &&
        !this.isLoadingCandidate &&
        this.isShowCriticalApproval
      );
    },

    currentProjectSettings() {
      if (!this.projectId) {
        return {};
      }

      return this.$store.getters['projects/settings/getSettingsByProjectId'](
        this.projectId
      );
    },

    historyEvents() {
      const history = this.currentCandidate?.history;
      if (!history) return [];
      const events = JSON.parse(JSON.stringify(history)).reverse();
      if (!events || !events.length) return [];
      return events.map((event) => {
        const eventName = event.event;
        const text = this.tabsNames[eventName];
        return {
          ...event,
          text: `${text || eventName}`,
        };
      });
    },

    mostRecentHistoryText() {
      if (!this.historyEvents || !this.historyEvents.length) return '';
      return `${this.historyEvents?.[0]?.text}  on ${this.historyEvents?.[0]?.date}`;
    },

    ...mapGetters('projects', ['getProjectById']),
  },

  watch: {
    start(v) {
      if (v) {
        this.startShowProgress = true;
      }
    },

    PRDResponse(v) {
      if (v.length) {
        this.leftSwipeDialog = true;
      }
    },

    projectSettings() {
      if (this.isFinishedGolive || this.iscurrentGolive) {
        return;
      }
      this.maybeShowExpansionDialog();
      if (this.currentProjectName !== this.projectSettings.project_name) {
        this.currentProjectName = this.projectSettings.project_name;
      }
    },

    reviewCompleted(v) {
      if (v && this.isCalibration) {
        this.$emit('changecalibration', false);
        const project = {};
        project.is_in_auto_swipe_calibration = false;
        project.is_admin_in_auto_swipe_calibration = false;
        if (this.isInCalibrationNewProject) {
          project.is_in_calibration = false;
        }
        project.allow_calibration_disable = true;
        this.$store.dispatch('projects/settings/updateProject', {
          projectId: this.projectId,
          project,
        });
      }
    },

    isFinishedGolive() {
      this.$emit('updateGolive', this.isFinishedGolive || this.iscurrentGolive);
    },

    iscurrentGolive() {
      this.$emit('updateGolive', this.isFinishedGolive || this.iscurrentGolive);
    },

    candidateDisplay(v) {
      if (v.length === 0 && this.pageIdx > 1) {
        this.pageIdx = 1;
        this.candidateIndex = 0;
        this.loadCandidates();
        return;
      }
      if (v.length > 0 && this.candidateIndex > v.length - 1) {
        this.candidateIndex = v.length - 1;
      }
    },
  },

  mounted() {
    this.loadUserSettings();
    this.loadCandidates();
    this.leftSwipeDialog = this.shouldRenderPRD;
    this.maybeShowExpansionDialog();
    this.$emit('updateGolive', this.isFinishedGolive || this.iscurrentGolive);
  },

  methods: {
    onDisabledRightSide(v) {
      this.isDiabledRightSide = v;
    },

    maybeShowExpansionDialog() {
      if (this.projectSettings.peq_dict || this.projectSettings.is_peq) {
        if (this.projectSettings.is_self_serve) {
          this.selfServeExpansionDialog = true;
          return;
        }
        if (this.isSuperAdmin || !this.isPilot) {
          this.expansionDialog = true;
        }
      }
    },

    onChangeCalibrationCritical() {
      this.$emit('changecalibration', true);
      this.onChangeCalibration(true);
    },

    onChangeCalibration() {
      this.isShowCriticalApproval = false;
    },

    getCandidatesList(candidates) {
      const arr = candidates;
      if (this.candidateId) {
        let tmp = null;
        let ind = null;

        arr.forEach((item, i) => {
          if (this.candidateId === item._id) {
            tmp = item;
            ind = i;
          }
        });
        if (tmp) {
          arr.splice(ind, 1);
          arr.push(tmp);
        }
      }
      return arr;
    },

    handleTourFinished() {
      this.showReviewTour = false;
      this.$emit('tour-finished', 'self_serve_interested');
    },

    async loadUserSettings() {
      const { calendar_preferences } =
        (await this.$store.dispatch('user/LOAD')) || {};
      if (
        calendar_preferences &&
        calendar_preferences.calendars_avail.length > 0 &&
        calendar_preferences.calendar_synced.id === ''
      ) {
        this.calendarSetupNeeded = true;
        consola.info('Calendar setup needed');
      }
    },

    setLoading2(value) {
      this.loading2 = value;
    },

    showTooltipTour() {
      this.showReviewTour = true;
      this.$refs.tour.resetIndex();
    },

    changeSettingAndCloseModal(v) {
      this.$store.commit('projects/REMOVE_PRD', {
        projectId: this.projectId,
      });
      this.leftSwipeDialog = v;
    },

    saveAndCloseExpansionDialog() {
      this.expansionDialog = false;
    },

    closeSelfServeExpansionDialog() {
      this.selfServeExpansionDialog = false;
    },

    openProjectSettings() {
      this.$router.push(`/projects/edit/${this.projectId}?tab=7`);
    },

    startLoadingSearchProgress(v) {
      this.startLoad = v;
    },

    transitionUserToCalendarSetup() {
      this.showCalendarSetupDialog = false;
      this.$router.push('/calendar');
    },

    async loadCandidates() {
      this.loading = true;
      if (this.isPilot) {
        await this.$store.dispatch('projects/candidates/loadCandidates', {
          projectId: this.projectId,
          tab: 'UNDER_REVIEW',
          tmp: true,
          id: this.$route.query.candidate,
          pageIdx: this.pageIdx,
        });
        await this.$store.dispatch('projects/candidates/loadCandidates', {
          projectId: this.projectId,
          tab: this.tab,
          tmp: true,
          id: this.$route.query.candidate,
          pageIdx: this.pageIdx,
        });
      } else {
        await this.$store.dispatch('projects/candidates/loadCandidates', {
          projectId: this.projectId,
          tab: this.tab,
          id: this.$route.query.candidate,
          pageIdx: this.pageIdx,
        });
      }
      this.loading = false;
    },

    finishGolive() {
      this.onChangeCalibration(true);
      this.isFinished = true;
      this.$emit('finishGolive');
    },

    closeIntroHandler() {
      this.closeIntro2 = true;
      // this.onChangeCalibration(false);
    },

    updateStep(e) {
      if (e === false) {
        if (this.liveStep === 1) {
          this.failedAts = true;
        }
        if (this.liveStep === 2) {
          this.failedCalendar = true;
        }
      } else {
        if (this.liveStep === 1 && e === true) {
          this.failedAts = false;
        }
        if (this.liveStep === 2 && e === true) {
          this.failedCalendar = false;
        }
        this.liveStep = e;
      }
    },

    onOpenRightdrawer(val) {
      this.$refs.sidePanelRef?.onOpen(val);
    },

    async nextCandidate() {
      if (this.candidateIndex >= this.totalCandidates - 1) {
        this.candidateIndex = 0;
        if (this.pageIdx > 1) {
          this.pageIdx = 1;
          await this.loadCandidates();
        }
        return;
      }
      this.candidateIndex += 1;
      if (
        this.candidateIndex >= this.candidateDisplay.length &&
        this.candidateIndex < this.totalCandidates
      ) {
        this.pageIdx += 1;
        this.candidateIndex = 0;
        await this.loadCandidates();
      }
    },

    async previousCandidate() {
      if (this.candidateIndex === 0 && this.pageIdx === 1) return;

      if (this.candidateIndex === 0) {
        this.pageIdx -= 1;
        await this.loadCandidates();
        this.candidateIndex = this.candidateDisplay.length - 1;
      } else {
        this.candidateIndex -= 1;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bg-gradient {
  background: linear-gradient(
    180deg,
    rgba(230, 231, 235, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}

.card-pile {
  /* width: 77.5%; */
  padding-top: 3.9rem;
  padding-bottom: 3.9rem;
}
.calibration-toggle {
  position: absolute;
  top: 12px;
  right: 60px;
  z-index: 2;
}
.calibration-toggle.empty-case {
  top: auto;
  bottom: 20px;
}
.calibration-toggle__text {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #384955;
}
.none-calibration {
  right: 365px;
}
.center-spinner {
  top: 100px;
  left: calc(50% - 72px);
  position: absolute;
}
.project-go-live {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
}
.critical-approval-container {
  min-height: calc(100vh - 120px);
  padding: 50px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-intro-position {
  position: absolute;
  top: 0px;
  height: 100%;
  right: 70px;
  z-index: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  gap: 62px;
  padding-bottom: 109px;
  min-height: 700px;
}
.none-right-intro-position {
  right: 345px;
}
.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 1;
  min-height: 100vh;
}
.z-10 {
  z-index: 10;
}
.empty-state-golive {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .content {
    max-width: 510px;
    margin: 0 auto;
    padding-top: 80px;
  }
  h3 {
    color: #384955;
    font-size: 20px;
    font-weight: 700;
  }
  p {
    color: #384955;
    font-size: 14px;
    font-weight: 500;
    max-width: 809px;
    margin-top: 18px;
  }
  .logo-icon {
    width: 80px;
    height: 80px;
    padding: 8px;
    margin: 0 auto;
    background-color: #d8d8d8;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    img {
      max-width: 100%;
    }
  }
}
</style>
